import { ref } from '@nuxtjs/composition-api';
import { STOCK_STATUS } from '~/constants/StockStatus';
import useErrorHandler from '~/composable/useErrorHandler';
import { PURCHASE_CATEGORY } from '~/constants/PurchaseCategory';


export default function useInventory (appContext) {
  const hubbleClient = appContext.$hubble;
  if (!appContext || !hubbleClient) {
    throw new Error('You must provide the nuxt app context to use this composable');
  }
  const { performFlowFailure } = useErrorHandler()
  const cartInventoryStatus = ref(null);
  const outOfStockSkuList = ref([])
  const getInventory = async (sku) => {
    const res = await hubbleClient.inventory.getInventory(sku).catch(() => {
      performFlowFailure()
    })
    const inventory = res?.data
    if (inventory?.purchaseCategory !== PURCHASE_CATEGORY.PRE_ORDER &&
      inventory?.purchaseCategory !== PURCHASE_CATEGORY.BACK_ORDER &&
      inventory?.stockStatus === STOCK_STATUS.OUT_OF_STOCK) {
      cartInventoryStatus.value = STOCK_STATUS.OUT_OF_STOCK
      outOfStockSkuList.value.push(sku)
    }
    return inventory
  };
  const getCartInventoryStatus = (skuList) => {
    skuList.forEach(sku => getInventory(sku))
    setTimeout(() => {
      if (cartInventoryStatus.value === null) {
        cartInventoryStatus.value = STOCK_STATUS.IN_STOCK
      }
    }, 1000)
  }
  return {
    cartInventoryStatus,
    outOfStockSkuList,
    getInventory,
    getCartInventoryStatus
  }
}
